import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

/** 联系人 `churned_at` 有值时展示「已流失」；资料区与两处客户列表共用 */
export function ContactChurnedBadge({
  churnedAt,
  className,
}: {
  churnedAt: string | null | undefined;
  className?: string;
}) {
  if (!churnedAt) return null;

  return (
    <Badge
      variant="outline"
      className={cn(
        "shrink-0 border-amber-500/50 text-amber-700 dark:text-amber-400",
        className,
      )}
    >
      已流失
    </Badge>
  );
}
